import React from 'react';

export const AppFooter = () => {

    return (
        <div className="layout-footer">
            <div className="wrapper">
                <img src="assets/images/QUT_SQUARE_RGB_REV_SVG.svg" alt="qut-logo" className='logo'/>
                <span className="footer-text">Bacterial Polysaccharides Research Laboratory </span>
            </div>
        </div>
    );
}

export default AppFooter;